<meta name="viewport" content="width=device-width, initial-scale=1.0">
<svg class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np" width="100%" height="30"
preserveAspectRatio="xMinYMin meet">
  <rect width="100%" height="30"style="fill:#ccc;stroke-width:0;stroke:#FFFFFF;opacity:1;" />
  <rect width="100%" [style.width.%]="percent" height="30"style="fill:#277099;stroke-width:0;stroke:#FFFFFF;" />
</svg>


